'use client';

import type { ReactNode } from 'react';
import { RunnerRequestUiProvider, type RunnerRequestUiRuntime } from '@agentteams/runner-request/ui/runtime';
import { useWorkspaceScope } from '../hooks/useWorkspaceScope';
import { useIsDesktopApp } from '../hooks/useIsDesktopApp';
import { useUploadDraftAttachment, validateAttachmentFile } from '../hooks/queries/useAttachments';
import {
  usePromptPresets,
  useCreatePromptPresetMutation,
  useUpdatePromptPresetMutation,
  useDeletePromptPresetMutation,
} from '../hooks/queries/usePromptPresets';
import {
  searchCommandEntities,
  prefetchAvailableProviders,
  getCachedAvailableProviders,
  cacheAvailableProviders,
} from '../lib/tiptap/entityReferenceSearch';
import { searchEntities as searchProjectEntities } from '../lib/api/search';
import { fetchEntityTitle } from '../lib/tiptap/fetchEntityTitle';
import { buildEntityGoHref } from '../lib/entityGoLink';

export const webRunnerRequestUiRuntime: RunnerRequestUiRuntime = {
  useWorkspaceScope,
  useIsDesktopApp,
  useUploadDraftAttachment,
  validateAttachmentFile,
  usePromptPresets,
  useCreatePromptPresetMutation,
  useUpdatePromptPresetMutation,
  useDeletePromptPresetMutation,
  searchCommandEntities,
  prefetchAvailableProviders,
  getCachedAvailableProviders,
  cacheAvailableProviders,
  searchProjectEntities,
  fetchEntityTitle,
  buildEntityGoHref,
};

export const WebRunnerRequestUiProvider = ({ children }: { children: ReactNode }) => (
  <RunnerRequestUiProvider runtime={webRunnerRequestUiRuntime}>{children}</RunnerRequestUiProvider>
);
